package org.catharsis.spendtel.feature.data

enum class EventName {
    CREATED_ACCOUNT,
    LOGGED_IN,
    DELETED_ACCOUNT,
    SIGNED_OUT,
    FORGOT_PASSWORD,
    CLICKED_PRIVACY,
    CLICKED_TERMS,
    CLICKED_SUPPORT,
    SELECTED_FINANCIAL_GOAL,
    CHANGED_FINANCIAL_GOAL,
    UPLOAD_STATEMENTS_STARTED,
    UPLOAD_STATEMENTS_COMPLETED,
    REPORT_CREATE_STARTED,
    REPORT_CREATE_COMPLETED,
    REPORT_CREATE_FAILED,
    REPORT_DELETED,
    PAYWALL_SHOWN,
    PURCHASE_STARTED,
    PURCHASE_COMPLETED,
    PURCHASE_CANCELLED,
    SHARE_SUMMARY,
    SHARE_CARD,
    SHARE_IMAGE,
    SHARE_LINK_CREATED,
    SHARE_FAILED,
}

enum class ScreenName {
    LANDING_SCREEN,
    AUTHENTICATION_SCREEN,
    FINANCIAL_GOAL_SCREEN,
    SETTINGS_SCREEN,
    PRIVACY_POLICY_SCREEN,
    TERMS_AND_CONDITIONS_SCREEN,
    CONTACT_SUPPORT_SCREEN,
    HOME_SCREEN,
    EXPENSE_REPORT_SCREEN,
    PUBLIC_SHARE_SCREEN,
}
